import { render, staticRenderFns } from "./UserQuickAccessManagement.vue?vue&type=template&id=11b0f40a&scoped=true&"
import script from "./UserQuickAccessManagement.vue?vue&type=script&lang=js&"
export * from "./UserQuickAccessManagement.vue?vue&type=script&lang=js&"
import style0 from "./UserQuickAccessManagement.vue?vue&type=style&index=0&id=11b0f40a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b0f40a",
  null
  
)

export default component.exports